import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { SplitPaymentToggleContent } from './SplitPaymentToggleContent';
import InformationCircleIcon from './icons/InformationCircleIcon';
import TooltipComponent from '../../../utils/TooltipComponent';
import { AGENCY_BUNDLE_ID } from '../../../utils/AgencyBundleProducts';

export function SplitPaymentToggle(props) {
	const {
		cartData,
		addToCart,
		coupon,
		is100PercentCouponApplied,
		agencyBundle,
	} = props;

	const toggleRef = useRef();
	const [isChecked, setIsChecked] = useState(false);

	const isSplitSelected = useMemo(() => {
		const selected = cartData?.splits?.filter(
			each =>
				parseInt(each.price_id) ===
				parseInt(agencyBundle?.options.price_id)
		);

		return selected?.length === 1;
	}, [cartData, agencyBundle]);

	useEffect(() => {
		if (isSplitSelected) {
			setIsChecked(true);
		}
	}, [isSplitSelected]);

	useEffect(() => {
		if (
			isSplitSelected &&
			coupon?.is_valid &&
			coupon?.type === 'percent' &&
			coupon?.amount === 100
		) {
			handleToggle({ target: { checked: false, value: 2 } });
		}
	}, [coupon, isSplitSelected]);

	const updateCart = useCallback(
		e => {
			let product = {
				download_id: AGENCY_BUNDLE_ID,
				price_id: parseInt(e.target.value),
			};

			if (coupon?.is_valid) {
				product.discount = coupon.code;
			}

			addToCart(product, true, true);
		},
		[cartData, coupon]
	);

	const handleToggle = useCallback(
		e => {
			if (!e.target.checked && isSplitSelected) {
				updateCart(e);
			}

			setIsChecked(Boolean(e.target.checked));
		},
		[isSplitSelected]
	);

	if (!cartData?.splits) {
		return null;
	}

	return (
		<>
			<div className="wp-checkout-flex wp-checkout-flex-center wp-checkout-flex-space-between wp-checkout-split-payment-card">
				<div className="wp-checkout-flex wp-checkout-flex-center ">
					<h4 className="wp-checkout-font-base wp-checkout-split-payment-card-header">
						Would you like to split your payment?
					</h4>
					<TooltipComponent tooltipText="By choosing split payments, the stated amount will be automatically charged to your card each month.">
						<span className="line-height-0 wp-checkout-split-payment-card-header-icon">
							<InformationCircleIcon />
						</span>
					</TooltipComponent>
				</div>
				<label className="switch">
					<input
						ref={toggleRef}
						type="checkbox"
						value={2}
						onChange={handleToggle}
						checked={isChecked}
					/>
					<span className="slider round"></span>
				</label>
			</div>

			{isChecked && <SplitPaymentToggleContent {...props} />}
		</>
	);
}
